export function getChangedFields<T extends Record<string, unknown>>(saved: T, draft: T): Partial<T> {
  const changes: Partial<T> = {};

  for (const key in draft) {
    if (!Object.is(saved[key], draft[key])) {
      changes[key] = draft[key];
    }
  }

  return changes;
}
